import { Component, OnInit, Input } from '@angular/core';
import { BaseService } from '../../../base/shared/services/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { FilterService } from 'src/modules/base/services/filter.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { AIService } from 'src/modules/base/components/aiml/services/ai.service';

@Component({
    selector: 'kx-track-status',
    templateUrl: './track-status.component.html',
    styleUrls: ['./track-status.component.scss'],
    standalone: false
})
export class TrackStatusComponent implements OnInit {
  @Input() input: any;
  public _currentData: any = {};
  result: any[];
  keys: any;
  page: any = 1;
  limit: any = 10;
  activeTab = "pending";
  gridData: any;
  sortData: any;
  applyFilter: boolean = false;
  filterValue: any;
  limitChange: boolean = false;
  dataGridConfig: any = {
    "viewAll": true,
    "hideSearchBox": false,
    "hideResult": false,
    "customButtonsAllowed": false,
    "allowPagination": true,
  }
  savedFilterInfo: any;
  constructor(
    private baseService: BaseService,
    private router: ActivatedRoute,
    private route: Router,
    private appService: AppService,
    private loader: LoaderService,
    public utilService: UtilService,
    private filterService: FilterService,
    private aiService: AIService,
    private storageService?: StorageService
  ) { }

  ngOnInit() {
    this.baseService.getResourceDef('encounter_dischargeClearance', (resouceDef) => {
      if (resouceDef) {
        this._currentData.resouceDef = resouceDef;
        this._currentData.blocks = resouceDef; //for filter fields
        if(this._currentData.resouceDef.list?.filter?.blocks[0]?.fields?.filter(x=>x.name == "stage_id").length > 0){
          if(this.activeTab == "pending"){
            this._currentData.resouceDef.list.filter.blocks[0].fields.find(x=>x.name == "stage_id").visible = true;
          }else{
            this._currentData.resouceDef.list.filter.blocks[0].fields.find(x=>x.name == "stage_id").visible = false;
          }
        }
        this.dataGridConfig.complex_search = resouceDef.list.complex_search;
        this.dataGridConfig.resource = resouceDef.resource
        this.dataGridConfig.aiSummary = {}
           /******** AI SUMMARY ****************/
            this.aiService.checkIfAIAvailable(resouceDef,AIService.GRID_SUMMARY,(aiResp)=>{
              if(resouceDef.config?.ai != undefined){
                if (this.dataGridConfig.aiSummary == undefined) {
                  this.dataGridConfig.aiSummary = {};
                }else[
                  this.dataGridConfig.aiSummary = JSON.parse(JSON.stringify(this.dataGridConfig.aiSummary))
                ]
                this.dataGridConfig.aiSummary.resourceDef = aiResp;
                this.dataGridConfig.aiSummary.dynamic_key = resouceDef.resource;        
                this.dataGridConfig.aiSummary.filter = "";
                this.dataGridConfig.aiSummary.configLoaded = true;
              }
            })
           /******** AI SUMMARY ****************/
      }
    });
    this.router.params.subscribe(res => {
      if (res) {
        this._currentData.patientType = res.patientType;
        this._currentData.applcationName = this.appService.getApplication();
        /**added condition for pagination on change menu**/
        if (this.gridData != undefined)
          delete this.gridData;
        if (this._currentData.finalKeys != undefined)
          delete this._currentData.finalKeys;
        /**********************************************/
        this.getHeading();
        let sessionData = JSON.parse(sessionStorage.getItem('savedFilterValue'))
        let currentUrl = this.route.url
        if(sessionData && sessionData['savedFilter'] != "" && sessionData['filterValue'] && (currentUrl == sessionData.url)){
         this.activeTab = sessionData['activeTab']
         this.applyFilter = true
         this.dataGridConfig.filterLabel = sessionData['savedFilter']
         this.filterValue = sessionData['filterValue']
        }
        this.hasData();
      }
    });
    this.baseService.setTitle("Clearance Status");
    this.baseService.backNavigation = false
  }

  hasActiveTab(tab: any) {
    this.activeTab = tab;
    this._currentData.filterName = "ip";
    this.applyFilter = false;
    this.dataGridConfig.filterLabel = false
    if(this._currentData.resouceDef.list?.filter?.blocks[0]?.fields?.filter(x=>x.name == "stage_id").length > 0){
    if(this.activeTab == "pending"){
      this._currentData.resouceDef.list.filter.blocks[0].fields.find(x=>x.name == "stage_id").visible = true;
    }else{
      this._currentData.resouceDef.list.filter.blocks[0].fields.find(x=>x.name == "stage_id").visible = false;
    }
  }
    let obj = {
      activeTab:this.activeTab,
      url:this.route.url
    }
    this.storageService.setSessionStorageData("savedFilterValue", obj,()=>
     {}
    )
    this.hasData();
  }

  hasData(search?, filter?) {
    //added condition for pagination on change menu
    if (this.limitChange == false) {
      this.page = 1;
      this.limit = 10;
    }
    this._currentData.filterKey = search;
    if (filter == undefined && this._currentData.filterName == undefined) {
      this._currentData.filterName = "ip";
    } else if (filter != undefined) {
      this._currentData.filterName = filter.target.value;
    }
    var gridData = {
      "args": "application:" + this._currentData.applcationName,
      "query_id": this.activeTab == "pending" ? "GET_ALL_PATIENT_DISCHARGE_CLEARANCE_PENDING_DATA" : "GET_ALL_PATIENT_DISCHARGE_CLEARANCE_COMPLETED_DATA",
      "page_size": this.limit,
      "page_no": this.page - 1
    };
    this.limitChange = false;
    if (this.input != undefined && this.input.filter) {
      if (this.applyFilter) {
        gridData['filter'] = this.filterValue + "," + this.input.filter
      } else
        gridData['filter'] = this.input.filter;
    } else if (this._currentData.patientType != undefined) {
      if (this.applyFilter)
        gridData['filter'] = "patientType:" + this._currentData.patientType.toUpperCase() + "," + this.filterValue
      else
        gridData['filter'] = "patientType:" + this._currentData.patientType.toUpperCase()
    } else {
      if (this.applyFilter)
        gridData['filter'] = "patientType:" + this._currentData.filterName.toUpperCase() + "," + this.filterValue
      else
        gridData['filter'] = "patientType:" + this._currentData.filterName.toUpperCase()
    }
    if (this._currentData.filterKey != undefined && this._currentData.filterKey) {
      gridData["search"] = this._currentData.filterKey.value;
      gridData["search_columns"] = this._currentData.filterKey.key ? this._currentData.filterKey.key : '';
    }
    if (this.sortData != undefined) {
      gridData['order_by'] = this.sortData
    }

    this.callApi(gridData);
  }
  getConfigValues(event){
    if (event.filterPrintInfo != undefined && event.filterPrintInfo){
    this.savedFilterInfo = event
    }
  }
  callApi(gridData) {
    if(this.dataGridConfig?.aiSummary != undefined){
      this.dataGridConfig.aiSummary.load = false;
      if(gridData["filter"] != undefined && gridData["filter"] != ""){
        this.dataGridConfig.aiSummary.filter = gridData["filter"]
      }
      if(this.activeTab == "completed"){
        if(gridData["filter"] != undefined && gridData["filter"] != ""){
          this.dataGridConfig.aiSummary.filter = this.dataGridConfig.aiSummary.filter+",status:completed"
        }
        else{
          this.dataGridConfig.aiSummary.filter = "status:completed"
        }
      }
      if(gridData["args"] != undefined && gridData["args"] != ""){
        this.dataGridConfig.aiSummary.args = gridData["args"]
      }
    }
    this.loader.showSpinner();
    this.baseService.getData(gridData, "", 'encounter_dischargeClearance', 'adt', this.activeTab == "pending" ? "GET_ALL_PATIENT_DISCHARGE_CLEARANCE_PENDING_DATA" : "GET_ALL_PATIENT_DISCHARGE_CLEARANCE_COMPLETED_DATA").subscribe(data => {
      if(this.dataGridConfig?.aiSummary != undefined &&data.url != undefined && data.url){
        this.dataGridConfig.aiSummary["final_url"]  = data.url
      }
      this.loader.hideSpinner();
      this._currentData.listData = data;
      if (this._currentData.listData.resource) {
        this.result = [];
        for (let i = 0; i < this._currentData.listData.resource.length; i++) {
          if (this._currentData.listData.resource[i]['data'].length > 0) {
            var Obj = {};
            this._currentData.listData.resource[i]['data'] = this._currentData.listData.resource[i]['data'].sort(function (a, b) { return a.sequence - b.sequence })
            for (let j = 0; j < this._currentData.listData.resource[i].data.length; j++) {
              Obj['uhId'] = this._currentData.listData.resource[i]['uhId'];
              Obj['patient_age'] = this._currentData.listData.resource[i]['patient_age'];
              Obj['patient_name'] = this._currentData.listData.resource[i]['patient_name'];
              Obj[this._currentData.listData.resource[i]['data'][j]['stage_id']] = this._currentData.listData.resource[i]['data'][j]['status'];
            }
            Obj['encounter_id'] = this._currentData.listData.resource[i]['encounter_id'];
            Obj['tableId'] = this._currentData.listData.resource[i]['table_id'];
            Obj['critical_tat_expired'] = this._currentData.listData.resource[i]['critical_tat_expired'];
            Obj['warning_tat_expired'] = this._currentData.listData.resource[i]['warning_tat_expired'];
            Obj['care_type'] = this._currentData.listData.resource[i]['care_type_name'];
            Obj['care_type_name'] = this._currentData.listData.resource[i]['care_type_name'];
            Obj['bed'] = this._currentData.listData.resource[i]['bed'];
            Obj['ward'] = this._currentData.listData.resource[i]['ward'];
            Obj['payer_name'] = this._currentData.listData.resource[i]['payer_name'];
            Obj['payer_type_name'] = this._currentData.listData.resource[i]['payer_type_name'];
            Obj['discharge_intimation_time'] = this._currentData.listData.resource[i]['discharge_intimation_time'];
            Obj['dischargeSummaryFinalDateTime'] = this._currentData.listData.resource[i]['dischargeSummaryFinalDateTime'];
            this.result.push(Obj);
          }
        }
        // this.getHeading()
        this.gridData = {}
        this.gridData['resource'] = this.result;
        this.gridData['count'] = this._currentData.listData.count;
      }
      if(this.dataGridConfig?.aiSummary != undefined){
        this.dataGridConfig.aiSummary.load = true;
      }
    })
  }

  getHeading() {
    var data = {}
    data['filter'] = "patientType:" + this._currentData.patientType.toUpperCase()
    this.baseService.getData(data, "", "encounter_dischargeClearance", "adt", "GET_CLEARANCE_STAGES").subscribe((res) => {
      this._currentData._resource = res.resource
      var stageData = this._currentData._resource.sort(function (a, b) { return a.finalSequence - b.finalSequence })
      var arr = []
      for (let i = 0; i < stageData.length; i++) {
        arr.push(stageData[i].stage_id)
      }
      this.headingArray(arr)
    })
  }
  headingArray(arr: any) {
    this.keys = [];
    for (let i = 0; i < arr.length; i++) {
      var s = {};
      s['heading'] = this._currentData._resource.find(x => x.stage_id == arr[i]) == undefined ? arr[i] : this._currentData._resource.find(x => x.stage_id == arr[i]).stage_name;
      s["card_tag"] = null;
      s["order"] = i + 10;//set a/c json field
      s["sortable"] = true;
      s["type"] = "metro";
      s["name"] = arr[i];
      this.keys.push(s)
    }
    if (this._currentData.resouceDef && this._currentData.resouceDef.list.gridButtons != undefined) {
          if (this.keys.find(elem => (elem.name == 'gridButton')) == undefined) {
            this._currentData.resouceDef.list.gridButtons.name = "gridButton";
            this.keys.push(this._currentData.resouceDef.list.gridButtons);
          }
        }
    this.keys.push(this.menuJson())
    this.keys.unshift(...this._currentData.resouceDef.list.fields);
    this._currentData.finalKeys = this.keys.sort(function (a, b) { return a.order - b.order })
    console.log("finalKeys", this._currentData.finalKeys);
  }

  menuJson() {
    return {
      "heading": "",
      "sortable": false,
      "order": 50,
      "name": "",
      "config": {
        "type": "ellipse",
        "buttonMenu": [
          {
            "action": "custom",
            "label": "Details",
            "key": "tableId",
            "redirectLink": "/encounter_dischargeClearance/patient_clearence",
            "conditions": []
          }
        ]
      }
    }
  }

  redirect(action: any) {
    if (action && action.actionType && action.actionType.redirectLink && action.actionType.redirectLink == "/view_detail_format_ip/billingDesignviewdetails") {
      this._currentData.applcationName = "billing"
      let args = "uhId:" + action.data.uhId + ",admissionId:" + (action.data.encounter_id ? action.data.encounter_id : action.data.admissionId)
      this.route.navigate(["/" + this._currentData.applcationName + action.actionType.redirectLink], { queryParams: { returnUrl: this.route.url, key: action.data[action.actionType.key], redirectToBilling: true,  query_params : args } })
    }
    else {
      this.route.navigate(["/" + this._currentData.applcationName + action.actionType.redirectLink], { queryParams: { returnUrl: this.route.url, key: action.data[action.actionType.key] } })
    }
    sessionStorage.setItem("currentData", JSON.stringify(action.data));
  }

  public onFilter(event) {
    this.hasData(event);
  }

  sortChanges(event: any) {
    if (event == undefined)
      this.sortData = undefined;
    else
      this.sortData = event.key + " " + event.value;
    this.hasData();
  }

  onLimit(event: any) {
    this.limitChange = true;
    this.limit = event.target.value;
    this.page = 1;
    this.hasData();
  }

  onPageChanged(event: any) {
    this.limitChange = true;
    this.page = event
    this.hasData();
  }
  bindDataToGrid(event: any) {
    this.loader.showSpinner();
    if (event != undefined)
      this.applyFilter = true;
    else
      this.applyFilter = false;
    this.filterValue = this.filterService.removeDuplicateKeysFromString({ "filter": event });
    let obj = {
      savedFilter:this.savedFilterInfo ? this.savedFilterInfo.filterPrintInfo: '',
      filterValue:this.filterValue,
      activeTab:this.activeTab,
      url:this.route.url
    }
    this.storageService.setSessionStorageData("savedFilterValue", obj,()=>
     {}
    )
    this.hasData();
  }
}
